'use client';

import { Children, cloneElement } from 'react';

import { useMenuContext } from './MenuProvider';

import type { FC, ReactNode } from 'react';

export interface ToggleProps {
  children: ReactNode;
}

export const MenuHoverEnter: FC<ToggleProps> = ({ children }) => {
  const { onMouseEnter, open } = useMenuContext();

  return (
    <>
      {Children.map( children, (child) =>
        cloneElement( child, {
          onMouseEnter,
          'aria-controls': open ? 'menu' : void 0,
          'aria-haspopup': 'true',
          'aria-expanded': open ? 'true' : void 0,
        } ) )}
    </>
  );
};
